"use strict";

import { initializeCarousel } from "../swiperCarousel";
import breakpoints from "../../helpers/breakpoints";
import constants, { PRODUCT_SALE_TYPE } from "../../constants";
import { appendQueryParams } from "../../util/urlHelpers";
import gtm from "../../gtm";
import initializeCartFaq from "../cartFaq";
import { debounce } from "lodash";
import scrollAnimate from "../../../../../../../app_storefront_base/cartridge/client/default/js/components/scrollAnimate";

let cartData;

const initAddToCartNBOListener = () => {
    $(".js-offerTile-nbo-cta-subscribe").on("click", function (e) {
        e.preventDefault();
        const $buttonElement = $(this);
        const $cartContainer = $(".js-cart-container");
        const isNBOSelected  = $buttonElement.data("nbo-selected");
        const $nboModal      = $(".js-nbo-modal");

        const offerSource = constants.ADD_PRODUCT_TO_CART_SOURCE.OFFER_TILE;

        const url = appendQueryParams($buttonElement.attr("data-offer-url"), {
            source: offerSource,
            redirectToCheckout: $buttonElement.data("should-redirect-to-checkout"),
            nboSelected: isNBOSelected,
        });

        $buttonElement.removeClass("btn-primary-cta-buy").addClass("btn-primary-cta-buy-loading");

        $.ajax({
            url: url,
            type: "get",
            dataType: "json"
        }).done(function (response) {
            if (isNBOSelected) {
                const cartUrl              = response.cartUrl;
                const updateData           = response.data;
                const customerAssetPlan    = response.data.customerPlan.assetId;
                const currentScrolPosition = document.documentElement.scrollTop || document.body.scrollTop;

                updateCartDOMPromise(
                    cartUrl,
                    $cartContainer,
                    currentScrolPosition,
                    null,
                    customerAssetPlan
                ).then(() => {
                    $nboModal.toggleClass("show", false);
                    updateCartDataDataset($cartContainer, updateData);
                });
            }
        });
    });
};

const setCollapsableElementsEventListeners = () => {
    const $cartSummaryContainer = $(".js-cart-summary");
    const $cartHaveCoupon       = $(".js-cart-have-coupon");

    if ($cartSummaryContainer.length !== 0) {
        const $summaryCollapseTrigger = $(".js-cart-summary-collapse", $cartSummaryContainer);

        $summaryCollapseTrigger.on("click", function () {
            const $collapseTrigger    = $(this);
            const targetSelector      = $collapseTrigger.data("collapse-target");
            const $target             = $(targetSelector);
            const $headerFloatingMenu = $(".js-sticky-on-scroll-up");

            $headerFloatingMenu.css("z-index", "2");
            $target.toggleClass("open");
        });
    }

    if ($cartHaveCoupon.length !== 0) {
        $cartHaveCoupon.on("click", function () {
            const $collapseTrigger    = $(".js-cart-summary-collapse");
            const targetSelector      = $collapseTrigger.data("collapse-target");
            const $target             = $(targetSelector);
            const $headerFloatingMenu = $(".js-sticky-on-scroll-up");

            $headerFloatingMenu.css("z-index", "2");
            $target.toggleClass("open");
        });
    }
};

function lockScrollAnchoring() {
    document.documentElement.style.overflowAnchor = "none";
    document.body.style.overflowAnchor            = "none";
}

function applyScrollAfterCartUpdate(currentScroll, isLastInteractedCategoryVisibleOnUpdatedData) {
    function restoreScroll() {
        const maxScroll    = Math.max(0, (document.documentElement.scrollHeight - window.innerHeight));
        const targetScroll = isLastInteractedCategoryVisibleOnUpdatedData && currentScroll <= maxScroll
            ? currentScroll
            : 0;

        document.documentElement.scrollTop = document.body.scrollTop = targetScroll;
    }

    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            restoreScroll();

            setTimeout(() => {
                restoreScroll();

                document.documentElement.style.overflowAnchor = "";
                document.body.style.overflowAnchor            = "";
            }, 400);
        });
    });
}

/**
 * Function to make an ajax call to replace products with variants
 * @param {String} removedProductId - removed product Id.
 * @param {String} replaceProductsAjaxUrl - url to make ajax call.
 * @returns {void}
 */
function productReplacementAjax(removedProductId, replaceProductsAjaxUrl, currentScroll, lastInteractedCategoryId, lastInteractedAssetId) {
    const $container    = $(".js-cart-container");

    cartData          = $container.data("cart-data");
    const showCartUrl = $container.data("cart-show-url");

    $.ajax({
        url: replaceProductsAjaxUrl,
        type: "get",
        dataType: "json",
        data: {
            pid: removedProductId
        },
        success: function (response) {
            cartData = response.data;
            updateCartDataDataset($container, cartData);

            if (response.isFurtherReplacementRequired) {
                productReplacementAjax(response.removedProductId, response.replaceProductsAjaxUrl, currentScroll, lastInteractedCategoryId, lastInteractedAssetId);
            } else {
                updateCartDOM(showCartUrl, $container, currentScroll, lastInteractedCategoryId, lastInteractedAssetId);
            }
        },
        error:  (err) => handleErrorOnCartUpdate(err, currentScroll, lastInteractedCategoryId, lastInteractedAssetId)
    });
}

function replaceCartSectionsFromHtml($container, $updatedCartDOM) {
    const $newSummary     = $updatedCartDOM.find(".js-cart-summary").first();
    const $currentSummary = $container.find(".js-cart-summary").first();

    if ($newSummary.length && $currentSummary.length) {
        $currentSummary.replaceWith($newSummary.clone());
    }

    const $newCategoryList     = $updatedCartDOM.find(".js-category-list").first();
    const $currentCategoryList = $container.find(".js-category-list").first();

    if ($newCategoryList.length && $currentCategoryList.length) {
        $currentCategoryList.replaceWith($newCategoryList.clone());
    }

    const $newPromotions     = $updatedCartDOM.find(".js-cart-summary-promotions").first();
    const $currentPromotions = $container.find(".js-cart-summary-promotions").first();

    if ($newPromotions.length && $currentPromotions.length) {
        $currentPromotions.replaceWith($newPromotions.clone());
    }

    const $newTotal     = $updatedCartDOM.find(".js-cart-summary-total").first();
    const $currentTotal = $container.find(".js-cart-summary-total").first();

    if ($newTotal.length && $currentTotal.length) {
        $currentTotal.replaceWith($newTotal.clone());
    }

    const $newFloatingTotal     = $updatedCartDOM.find(".js-cart-summary-floating-total").first();
    const $currentFloatingTotal = $container.find(".js-cart-summary-floating-total").first();

    if ($newFloatingTotal.length && $currentFloatingTotal.length) {
        $currentFloatingTotal.replaceWith($newFloatingTotal.clone());
    }

    if ($container.find(".js-cart-summary-list .js-cart-summary-item").length === 0) {
        $container.find(".js-cart-summary-empty").removeAttr("hidden");
        $container.find(".js-cart-submit-btn").toggleClass("disabled", true);
    }
}

function parseCartDataFromContainer($el) {
    if (!$el || !$el.length) {
        return null;
    }

    let raw = $el.data("cart-data");

    if (raw && typeof raw === "object") {
        return raw;
    }

    if (typeof raw !== "string") {
        raw = $el.attr("data-cart-data");
    }

    if (!raw || typeof raw !== "string") {
        return null;
    }

    const decoded = raw.replace(/&quot;/g, "\"").replace(/&#39;/g, "'").replace(/&amp;/g, "&");

    try {
        return JSON.parse(decoded);
    } catch (e) {
        try {
            return JSON.parse(raw);
        } catch (e2) {
            return null;
        }
    }
}

function parseCartShowResponse(response) {
    if (!response || typeof response !== "string") {
        return { $root: $(), $container: $() };
    }

    const $root      = $("<div>").html(response);
    const $container = $root.find(".js-cart-container").first();

    return { $root: $root, $container: $container };
}

const updateCartDOM = (showCartUrl, $container, currentScroll, lastInteractedCategoryId, lastInteractedAssetId) => {
    $.ajax({
        url: showCartUrl,
        type: "get",
        dataType: "html",
        success: function (response) {
            lockScrollAnchoring();
            $container.toggleClass("fetching", false);

            const parsed               = parseCartShowResponse(response);
            const $updatedCartDOM      = parsed.$root;
            const $parsedContainer = parsed.$container;

            if (!$parsedContainer.length) {
                replaceCartSectionsFromHtml($container, $updatedCartDOM);
                return;
            }

            let cartDataFromContainer = parseCartDataFromContainer($parsedContainer);

            if (!cartDataFromContainer) {
                replaceCartSectionsFromHtml($container, $updatedCartDOM);
                return;
            }

            const $updateCartContainer = $(".js-cart-container", $updatedCartDOM);
            const updatedData          = $updateCartContainer.data("cart-data");

            updateCartDataDataset($container, updatedData);
            ensureBlBannerVisibility($container, updatedData);

            const $currentCategoryList          = $(".js-category-list", $container);
            const $updatedCategoryList          = $(".js-category-list", $updatedCartDOM);
            const $currentCartSummaryPromotions = $(".js-cart-summary-promotions", $container);
            const $updatedCartSummaryPromotions = $(".js-cart-summary-promotions", $updatedCartDOM);

            const isLastInteractedCategoryVisibleOnUpdatedData = lastInteractedAssetId
                ? updatedData.changeProductsList.find(
                    category =>
                        category.assetId.toString() === lastInteractedAssetId.toString()
                )
                : updatedData.categoryList.find(
                    category =>
                        category.categoryId === lastInteractedCategoryId.toString()
                );

            if (document.activeElement && document.activeElement.blur) {
                document.activeElement.blur();
            }

            //Get the state of the current category card element before it is unmounted from the DOM.
            const currentStateOfCategoryCards                  = [];

            $(".js-category-card", $currentCategoryList).each((index, element) => {
                const $categoryCard = $(element);

                currentStateOfCategoryCards.push({
                    categoryId: $categoryCard.data("category-id").toString(),
                    assetId: $categoryCard.data("asset-id")?.toString(),
                    isFromCart: !$categoryCard.data("customer-plan"),
                    isOpen: $categoryCard.hasClass("open"),
                    productsCarouselIndex: $categoryCard.find(".js-category-product-carousel .js-swiper-container").get(0).swiper.activeIndex,
                    servicesCarouselIndex: $categoryCard.find(".js-product-services-carousel:visible .js-swiper-container").get(0)?.swiper.activeIndex
                });
            });

            $currentCategoryList.empty();
            $currentCategoryList.html($updatedCategoryList.html());

            $currentCartSummaryPromotions.empty();
            $currentCartSummaryPromotions.html($updatedCartSummaryPromotions.html());

            const $updatedCategoryCards = $(".js-category-card", $container);

            $updatedCategoryCards.each((index, element) => {
                const $categoryCard                     = $(element);
                const categoryId                        = $categoryCard.data("category-id").toString();
                const assetId                           = $categoryCard.data("asset-id")?.toString();
                const isCartCategory                    = !$categoryCard.data("customer-plan");
                const categoryState                     = currentStateOfCategoryCards.find(category => category.categoryId === categoryId && (!category.assetId || category.assetId?.toString() === assetId));
                const categoryCardData                  = isCartCategory ? updatedData.categoryList.find(category => category.categoryId === categoryId) : updatedData.changeProductsList.find(category => category.assetId.toString() === assetId);

                if (!categoryCardData) {
                    return;
                }

                const hasReachedMaximumQuantity         = categoryCardData.currentQty >= categoryCardData.maxQty && categoryCardData.maxQty !== 1;
                const $categoryCarouselSwiperContainers = $(".js-swiper-carousel", $categoryCard);
                const categoryStillHasItems             = categoryCardData.currentQty > 0;

                if (categoryState?.isOpen && categoryStillHasItems) {
                    const $categoryCardContent       = $(".js-category-content", $categoryCard);

                    $categoryCard.toggleClass("open", true);
                    //The category content wrapper has a transition animation as it expands, since this is not desired on the update of the cart DOM
                    //The following code remove the transition, set the height and then re-add the transition after it's finished
                    const transitionSetting = $categoryCardContent.css("transition");

                    $categoryCardContent.css("transition", "none");
                    $categoryCardContent.css("max-height", `${$categoryCardContent.prop("scrollHeight")}px`);
                    setTimeout(() => { $categoryCardContent.css("transition", transitionSetting); }, 1000);
                }

                if (hasReachedMaximumQuantity) {
                    const $steppersPlusOfCategory = $(".js-stepper-plus", $categoryCard);

                    $steppersPlusOfCategory.toggleClass("disabled", hasReachedMaximumQuantity);
                    $(".js-category-full-quantity", $categoryCard).removeAttr("hidden");
                } else {
                    $(".js-category-full-quantity", $categoryCard).attr("hidden", "true");
                }

                $categoryCarouselSwiperContainers.each((index, carouselWrapper) => {
                    const $carouselWrapper = $(carouselWrapper);
                    const carouselSwiper   = initializeCarousel($carouselWrapper, assetId);

                    if ($carouselWrapper.hasClass("js-category-product-carousel")) {
                        carouselSwiper.slideTo(categoryState?.productsCarouselIndex || 0, 0, true);
                    }

                    if ($carouselWrapper.hasClass("js-product-services-carousel") && $carouselWrapper.is(":visible")) {
                        carouselSwiper.slideTo(categoryState?.servicesCarouselIndex || 0, 0, true);
                    }
                });

                renderSelectedProductsOnCategoryCardDescription($categoryCard, categoryCardData);
            });

            //Update the visual of the stepper input field. If the value is 1, the minus button is hidden and the trash button is shown
            $(".js-stepper-input", $container).each(function () {
                const $stepperInput = $(this);
                const value         = parseInt($stepperInput.val(), 10);
                const $stepperTrash = $stepperInput.siblings(".js-stepper-trash");
                const $stepperMinus = $stepperInput.siblings(".js-stepper-minus");

                if (value === 1) {
                    $stepperMinus.hide();
                    $stepperTrash.show();
                } else {
                    $stepperMinus.show().toggleClass("disabled", value === 0);
                    $stepperTrash.hide();
                }
            });

            applyScrollAfterCartUpdate(currentScroll, isLastInteractedCategoryVisibleOnUpdatedData);

            updateCouponDOM($container, $updatedCartDOM);
            updateCartCounter(updatedData.productsInCartQty);
            updateMiniCartDOM($container, updatedData.minicart, !!updatedData.customerPlan, $updatedCartDOM);
            toggleEmptyCartLayout($container, updatedData);
            updateCartSummaryTotalDOM($container, $updatedCartDOM);
            setCardButtonClasses();
        },
        error: function () {
            $container.toggleClass("fetching", false);
            window.location.reload();
        }
    });
};

const updateCartDOMPromise = (
    showCartUrl,
    $container,
    currentScroll,
    lastInteractedCategoryId,
    lastInteractedAssetId
) => new Promise((resolve, reject) => {
    $.ajax({
        url: showCartUrl,
        type: "get",
        dataType: "html",
        success: function (response) {
            lockScrollAnchoring();
            $container.toggleClass("fetching", false);

            const parsed               = parseCartShowResponse(response);
            const $updatedCartDOM      = parsed.$root;
            const $updateCartContainer = parsed.$container;
            let updatedData            = parseCartDataFromContainer($updateCartContainer);

            if (!updatedData) {
                replaceCartSectionsFromHtml($container, $updatedCartDOM);
                resolve();
                return;
            }

            const $currentCategoryList                         = $(".js-category-list", $container);
            const $updatedCategoryList                         = $(".js-category-list", $updatedCartDOM);
            const isLastInteractedCategoryVisibleOnUpdatedData = lastInteractedAssetId ? updatedData.changeProductsList.find(category => category.assetId.toString() === lastInteractedAssetId.toString()) : updatedData.categoryList.find(category => category.categoryId === lastInteractedCategoryId.toString());

            if (document.activeElement && document.activeElement.blur) {
                document.activeElement.blur();
            }

            //Get the state of the current category card element before it is unmounted from the DOM.
            const currentStateOfCategoryCards                  = [];

            $(".js-category-card", $currentCategoryList).each((index, element) => {
                const $categoryCard = $(element);

                currentStateOfCategoryCards.push({
                    categoryId: $categoryCard.data("category-id").toString(),
                    assetId: $categoryCard.data("asset-id")?.toString(),
                    isFromCart: !$categoryCard.data("customer-plan"),
                    isOpen: $categoryCard.hasClass("open"),
                    productsCarouselIndex: $categoryCard.find(".js-category-product-carousel .js-swiper-container").get(0).swiper.activeIndex,
                    servicesCarouselIndex: $categoryCard.find(".js-product-services-carousel:visible .js-swiper-container").get(0)?.swiper.activeIndex
                });
            });

            $currentCategoryList.empty();
            $currentCategoryList.html($updatedCategoryList.html());

            const $updatedCategoryCards = $(".js-category-card", $container);

            $updatedCategoryCards.each((index, element) => {
                const $categoryCard                     = $(element);
                const categoryId                        = $categoryCard.data("category-id").toString();
                const assetId                           = $categoryCard.data("asset-id")?.toString();
                const isCartCategory                    = !$categoryCard.data("customer-plan");
                const categoryState                     = currentStateOfCategoryCards.find(category => category.categoryId === categoryId && (!category.assetId || category.assetId?.toString() === assetId));
                const categoryCardData                  = isCartCategory ? updatedData.categoryList.find(category => category.categoryId === categoryId) : updatedData.changeProductsList.find(category => category.assetId.toString() === assetId);

                if (!categoryCardData) {
                    return;
                }

                const hasReachedMaximumQuantity         = categoryCardData.currentQty >= categoryCardData.maxQty && categoryCardData.maxQty !== 1;
                const $categoryCarouselSwiperContainers = $(".js-swiper-carousel", $categoryCard);
                const categoryStillHasItems             = categoryCardData.currentQty > 0;

                if (categoryState?.isOpen && categoryStillHasItems) {
                    const $categoryCardContent       = $(".js-category-content", $categoryCard);

                    $categoryCard.toggleClass("open", true);
                    //The category content wrapper has a transition animation as it expands, since this is not desired on the update of the cart DOM
                    //The following code remove the transition, set the height and then re-add the transition after it's finished
                    const transitionSetting = $categoryCardContent.css("transition");

                    $categoryCardContent.css("transition", "none");
                    $categoryCardContent.css("max-height", `${$categoryCardContent.prop("scrollHeight")}px`);
                    setTimeout(() => { $categoryCardContent.css("transition", transitionSetting); }, 1000);
                }

                if (hasReachedMaximumQuantity) {
                    const $steppersPlusOfCategory = $(".js-stepper-plus", $categoryCard);

                    $steppersPlusOfCategory.toggleClass("disabled", hasReachedMaximumQuantity);
                    $(".js-category-full-quantity", $categoryCard).removeAttr("hidden");
                } else {
                    $(".js-category-full-quantity", $categoryCard).attr("hidden", "true");
                }

                $categoryCarouselSwiperContainers.each((index, carouselWrapper) => {
                    const $carouselWrapper = $(carouselWrapper);
                    const carouselSwiper   = initializeCarousel($carouselWrapper, assetId);

                    if ($carouselWrapper.hasClass("js-category-product-carousel")) {
                        carouselSwiper.slideTo(categoryState?.productsCarouselIndex || 0, 0, true);
                    }

                    if ($carouselWrapper.hasClass("js-product-services-carousel") && $carouselWrapper.is(":visible")) {
                        carouselSwiper.slideTo(categoryState?.servicesCarouselIndex || 0, 0, true);
                    }
                });

                renderSelectedProductsOnCategoryCardDescription($categoryCard, categoryCardData);
            });

            //Update the visual of the stepper input field. If the value is 1, the minus button is hidden and the trash button is shown
            $(".js-stepper-input", $container).each(function () {
                const $stepperInput = $(this);
                const value         = parseInt($stepperInput.val(), 10);
                const $stepperTrash = $stepperInput.siblings(".js-stepper-trash");
                const $stepperMinus = $stepperInput.siblings(".js-stepper-minus");

                if (value === 1) {
                    $stepperMinus.hide();
                    $stepperTrash.show();
                } else {
                    $stepperMinus.show().toggleClass("disabled", value === 0);
                    $stepperTrash.hide();
                }
            });

            applyScrollAfterCartUpdate(currentScroll, isLastInteractedCategoryVisibleOnUpdatedData);

            updateCouponDOM($container, $updatedCartDOM);
            updateCartCounter(updatedData.productsInCartQty);
            updateMiniCartDOM($container, updatedData.minicart, !!updatedData.customerPlan, $updatedCartDOM);
            ensureBlBannerVisibility($container, updatedData);
            toggleEmptyCartLayout($container, updatedData);
            updateCartSummaryTotalDOM($container, $updatedCartDOM);
            setCardButtonClasses();
            resolve(response);
        },
        error: function (err) {
            $container.toggleClass("fetching", false);
            reject(err);
        }
    });
});

const updateCartDataDataset = ($container, updatedData) => {
    $container.data("cart-data", updatedData);
    $container.attr("data-cart-data", JSON.stringify(updatedData));
};

const ensureBlBannerVisibility = ($container, cartData) => {
    if (!cartData) return;
    const showBlBanner = !cartData.customerPlan
        && cartData.productsInCartQty > 0
        && cartData.cartHasOnlyBlForBanner === true
        && cartData.cartBlSpeedMatchesBannerList !== false;

    const $summary = $container.find(".js-cart-summary").length
        ? $container.find(".js-cart-summary").first()
        : $(".js-cart-summary").first();

    if (!$summary.length) return;

    let $banner = $summary.find(".cart-summary__blBanner");

    if (showBlBanner && !$banner.length) {
        const line1      = $summary.data("bl-banner-line1") || "Quer pagar menos? Adicione";
        const line2      = $summary.data("bl-banner-line2") || "+1 produto e ganhe desconto";
        const $newBanner = $(
            "<div class=\"contentSection__blBanner cart__blBanner cart-summary__blBanner\" role=\"status\" aria-live=\"polite\">"
            + "<p class=\"contentSection__blBanner-text\">" + line1 + "<br/><strong>" + line2 + "</strong></p></div>"
        );

        $summary.find(".cart-summary__content-header").after($newBanner);
        $banner = $summary.find(".cart-summary__blBanner");
    }

    if ($banner.length) {
        $banner.toggle(showBlBanner);
    }
};

const getMinicartDOM = (category) => {
    return $(`
        <div class="cart-summary__item js-cart-summary-item" data-category-id="${category.categoryId}" data-product-id="${category.productList[0].id}">
            <img class="cart-summary__item-image loading-content" src="${category.categoryIcon}" alt="" />
            <div class="cart-summary__item-image loading loading-h-16"></div>

            <div class="cart-summary__item-content">
                <div class="cart-summary__item-category loading-content">
                    <span class="cart-summary__item-name">${category.categoryName + " (" + category.quantity + ")"}</span>
                    <span class="cart-summary__item-category-price">${category.totalSelectedPrice}</span>
                </div>

                <div class="cart-summary__item-category loading loading-h-20"></div>

                <ul class="cart-summary__item-products js-cart-summary-item-products">
                    ${category.productList.map(renderProductMinicartDOM).join("\n")}
                </ul>
            </div>
        </div>
    `);
};

const renderProductMinicartDOM = (product) => {
    if (!product) { return ""; }

    if (product.isRegularProduct) {
        return categoryRegularProductMinicartDOM(product);
    }

    return categoryProductMinicartDOM(product);
};

const categoryRegularProductMinicartDOM = (product) => `
    <li class="js-category-product cart-summary__item-line" data-product-addition-source="${product.productAdditionSource}">
        <div class="cart-summary__item-regular-product-info">
            <div class="cart-summary__item-regular-product-image" >
                <img src="${product.image}" alt="${product.productName}" />
            </div>
            <div class="cart-summary__item-regular-product-details">
                <p class="cart-summary__item-regular-product-name">${product.displayName}</p>
                <div class="cart-summary__item-price-and-remove">
                    <p class="cart-summary__item-regular-product-price">${product.priceData.sale.formatted}</p>
                    <button type="button" class="cart-summary__item-remove js-remove-item-summary loading-content" data-pid="${product.id}" data-uuid="${product.uuid || ""}" aria-label="Remover item">
                        <i class="icon-trash-primary-color-6" aria-hidden="true"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="loading loading-h-16 mt-1"></div>
    </li>
`;

const categoryProductMinicartDOM = (product) => `
    <li class="js-category-product cart-summary__item-line" data-product-addition-source="${product.productAdditionSource}">
        <span class="cart-summary__item-description loading-content">${product.productName}${product.quantity > 1 ? " (" + product.quantity + ")" : ""}</span>
        <div class="cart-summary__item-price-and-remove">
            <p class="cart-summary__item-product-price loading-content">${product.priceData.sale.formatted}</p>
            <button type="button" class="cart-summary__item-remove js-remove-item-summary loading-content" data-pid="${product.id}" data-uuid="${product.uuid || ""}" aria-label="Remover item">
                <i class="icon-trash-primary-color-6" aria-hidden="true"></i>
            </button>
        </div>
        <div class="loading loading-h-16 mt-1"></div>
    </li>
    ${product.services && product.services.map((service) => `
        <li class="js-category-service cart-summary__item-line" data-service-addition-source="${service.serviceAdditionSource}">
            <span class="cart-summary__item-description loading-content">+ ${service.serviceName}</span>
            <div class="cart-summary__item-price-and-remove">
                <p class="cart-summary__item-product-price loading-content">${service.price.formatted}</p>
                <button type="button" class="cart-summary__item-remove js-remove-item-summary loading-content" data-pid="${service.serviceId}" data-uuid="${service.uuid || ""}" aria-label="Remover item">
                    <i class="icon-trash-primary-color-6" aria-hidden="true"></i>
                </button>
            </div>
            <div class="loading loading-h-16"></div>
        </li>
    `).join("\n")}
    ${product.isPrepaid ? `
        <li class="js-service-product cart-summary__item-line">
            <span class="cart-summary__item-description loading-content">Chip Pré</span>
            <div class="cart-summary__item-price-and-remove">
                <p class="cart-summary__item-product-price loading-content">Grátis</p>
            </div>
            <div class="loading loading-h-16"></div>
        </li>
    ` : ""}
`;

const updateMiniCartDOM = ($container, minicartData, isCustomerPlan, $updatedCartDOM = false) => {
    const $minicartSummaryContainer = $(".js-cart-summary", $container);
    const $minicartSummaryList      = $(".js-cart-summary-list", $minicartSummaryContainer);
    const $totalCartPrice           = $(".js-cart-total-price b", $minicartSummaryContainer);
    const $standardLabelContainer   = $(".js-standard-label", $updatedCartDOM);
    const $standardLabelMinicart    = $(".js-cart-summary-standard-label");

    $totalCartPrice.empty();
    $minicartSummaryList.empty();
    $standardLabelMinicart.empty();

    $totalCartPrice.html(minicartData.total.formatted);

    if (minicartData.categoryList && minicartData.categoryList.length !== 0) {
        $standardLabelMinicart.html($standardLabelContainer[0]);


        // If it's the plan change flow, show a minicart with different layout for the change/new sale products. Otherwise use the normal one.
        if (isCustomerPlan) {
            const planChangesLabel = $minicartSummaryList.data("change-plan-label");
            const newSalesLabel    = $minicartSummaryList.data("new-sale-label");

            const newSaleCategories     = minicartData.categoryList.filter((category) => category.operationType === PRODUCT_SALE_TYPE.NEW_SALE);
            const planChangesCategories = minicartData.categoryList.filter((category) => category.operationType === PRODUCT_SALE_TYPE.UPDATE);

            if (planChangesCategories.length !== 0) {
                $minicartSummaryList.append(`<span class="cart-summary__list-section loading-content">${planChangesLabel}</span>`);
                $minicartSummaryList.append("<div class=\"cart-summary__list-section loading loading-h-24\"></div>");
            }

            planChangesCategories.forEach((category) => {
                getMinicartDOM(category).appendTo($minicartSummaryList);
            });

            if (newSaleCategories.length !== 0) {
                $minicartSummaryList.append(`<span class="cart-summary__list-section loading-content">${newSalesLabel}</span>`);
                $minicartSummaryList.append("<div class=\"cart-summary__list-section loading loading-h-24\"></div>");
            }

            newSaleCategories.forEach((category) => {
                getMinicartDOM(category).appendTo($minicartSummaryList);
            });
        } else {
            minicartData.categoryList.forEach((category) => {
                getMinicartDOM(category).appendTo($minicartSummaryList);
            });
        }
    }

    if ($updatedCartDOM) {
        const $currentPromotionList = $(".js-promotion-list", $container);
        const $updatedPromotionList = $(".js-promotion-list", $updatedCartDOM);

        $currentPromotionList.replaceWith($updatedPromotionList);
    }
};

const buildRemoveCouponUrl = ($form, couponCode, uuid) => {
    const baseUrl = $form.data("remove-coupon-url");

    if (!baseUrl || !couponCode || !uuid) {
        return null;
    }

    const separator = baseUrl.indexOf("?") >= 0 ? "&" : "?";

    return baseUrl + separator + "code=" + encodeURIComponent(couponCode) + "&uuid=" + encodeURIComponent(uuid);
};

const showInvalidCouponProductsFeedback = ($promoCodeForm) => {
    const $couponInput  = $promoCodeForm.find(".coupon-code-field");
    const $errorMessage = $promoCodeForm.find(".coupon-error-message");
    const message       = $promoCodeForm.data("invalid-coupon-products-message") || "Cupom inválido para estes produtos";

    $couponInput.addClass("is-invalid");
    $couponInput.attr("aria-describedby", "invalidCouponCode");
    $errorMessage.empty().append(message);
};

const clearCouponFeedback = () => {
    const $promoCodeForm = $(".js-promo-code-form");

    $promoCodeForm.find(".coupon-code-field")
        .removeClass("is-invalid")
        .removeAttr("aria-describedby");
    $promoCodeForm.find(".coupon-missing-error").empty();
    $promoCodeForm.find(".coupon-error-message").empty();
};

const removeInvalidCoupon = ($promoCodeForm, discount) => {
    const removeUrl = buildRemoveCouponUrl($promoCodeForm, discount.couponCode, discount.UUID);

    if (!removeUrl) {
        return $.Deferred().reject().promise();
    }

    return $.ajax({
        url: removeUrl,
        type: "GET",
        dataType: "json"
    });
};

const updateCoupon = (showCartUrl, $currentCartSummary, _data, skipReload) => {
    const $addCouponBtn    = $(".js-add-coupon");
    const $removeCouponBtn = $(".js-remove-coupon");

    //Ajax call to get the updated render of the cart without triggering reload
    return $.ajax({
        url: showCartUrl,
        type: "get",
        dataType: "html",
        success: function (response) {
            const $updatedCartDOM          = $(response);

            updateCouponDOM($currentCartSummary, $updatedCartDOM);
            updateCartSummaryTotalDOM($currentCartSummary, $updatedCartDOM);
            $addCouponBtn.removeClass("btn-loading");
            $removeCouponBtn.removeClass("btn-loading");

            if (!skipReload) {
                window.location.reload();
            }
        }
    });
};

const updateCouponDOM = ($currentContainer, $updatedCartDOM) => {
    const $updatedCouponDisplay = $updatedCartDOM.find(".js-coupon-display");
    const $currentCouponDisplay = $currentContainer.find(".js-coupon-display");

    $currentCouponDisplay.replaceWith($updatedCouponDisplay);
    clearCouponFeedback();

    $updatedCouponDisplay.removeAttr("hidden");

    let hasCoupon = $updatedCouponDisplay.find(".coupon-applied").length > 0;

    if (hasCoupon) {
        $(".js-coupon-and-promo-input-wrapper").addClass("d-none");
    } else {
        $(".js-coupon-and-promo-input-wrapper").removeClass("d-none");
    }
};

const updateCartSummaryTotalDOM = ($currentContainer, $updatedCartDOM) => {
    const $updatedCartSummaryTotal = $updatedCartDOM.find(".js-cart-summary-total");
    const $currentCartSummaryTotal = $currentContainer.find(".js-cart-summary-total");

    const $updatedMobileCartSummaryTotal = $updatedCartDOM.find(".js-cart-summary-floating-total .js-cart-total-price");
    const $currentMobileCartSummaryTotal = $currentContainer.find(".js-cart-summary-floating-total .js-cart-total-price");

    const $updatedMobileCartSummaryCommitment = $updatedCartDOM.find(".js-cart-summary-floating-commitment");
    const $currentMobileCartSummaryCommitment = $currentContainer.find(".js-cart-summary-floating-commitment");

    $currentCartSummaryTotal.replaceWith($updatedCartSummaryTotal);
    $currentMobileCartSummaryTotal.replaceWith($updatedMobileCartSummaryTotal);
    $currentMobileCartSummaryCommitment.replaceWith($updatedMobileCartSummaryCommitment);
};

const updateCartCounter = (numberOfProducts) => {
    const $cartProductCounter                 = $(".js-minicart-qty");

    if (numberOfProducts === 0) {
        $cartProductCounter.attr("hidden", "true");
        $cartProductCounter.empty();
    } else {
        $cartProductCounter.removeAttr("hidden");
        $cartProductCounter.empty().text(numberOfProducts);
    }
};

const toggleEmptyCartLayout = ($container, cartData) => {
    const $emptyCartSummaryMessage = $(".js-cart-summary-empty", $container);
    const $couponsElements         = $(".js-coupon-and-promo", $container);
    const $cartSubmitButton        = $(".js-cart-submit-btn", $container);
    const $emptyCartModalButton    = $(".js-open-empty-modal", $container);

    $cartSubmitButton.on("click", () =>
        $cartSubmitButton.removeClass("btn-primary-cta-buy").addClass("btn-primary-cta-buy-loading"));

    if (
        cartData.minicart &&
        cartData.minicart.categoryList.length !== 0
    ) {
        //Hide cart empty message
        $emptyCartSummaryMessage.attr("hidden", true);
        //Enable the submit cart button
        $cartSubmitButton.toggleClass("disabled", !cartData.isReadyForCheckout);
        //Show the coupon input and display elements
        $couponsElements.removeAttr("hidden");
        const cartSegment = $(".js-header-tab.active li").first().text().trim();

        if (cartSegment) {
            localStorage.setItem("gtmSegment", cartSegment);
        }
        // Show empty cart modal button
        $emptyCartModalButton?.toggleClass("d-none", false);
    } else {
        //Show cart empty message
        $emptyCartSummaryMessage.removeAttr("hidden");
        //Disabled the submit cart button
        $cartSubmitButton.toggleClass("disabled", true);
        //Show the coupon input and display elements
        $couponsElements.attr("hidden", true);
        // Hide empty cart modal button
        $emptyCartModalButton?.toggleClass("d-none", true);
    }
};

const renderSelectedProductsOnCategoryCardDescription = ($categoryCard, categoryData) => {
    if (!categoryData) {
        return;
    }

    const $categoryDescription = $(".js-category-description", $categoryCard);
    const isCustomerPlan       = $categoryCard.data("customer-plan");

    if (!categoryData.selected) {
        $categoryDescription.html(isCustomerPlan ? $categoryDescription.data("customer-plan-description") : categoryData.categoryDescription);
        return;
    }

    const isOneProductOnly = categoryData.maxQty === 1 || categoryData.selectedProductId;

    if (isOneProductOnly) {
        const selectedProduct                    = categoryData.selectedProductId
            ? categoryData.productList.find((product) => product.id === categoryData.selectedProductId)
            : categoryData.productList.find((product) => product.selected);

        if (!selectedProduct) {
            return;
        }

        const selectedProductName                = selectedProduct.offerSubtitle;
        const selectedProductServicesNames       = selectedProduct.serviceOptionList
            .filter((service) => service.selected)
            .map((service) => service.name);
        const selectedProductServicesNamesString = selectedProductServicesNames.join(", ");
        const finalCategoryDescription           = `${selectedProductName}${
            selectedProductServicesNamesString ? " + " + selectedProductServicesNamesString : ""
        }`;

        $categoryDescription.html(finalCategoryDescription);
    } else {
        const selectedProducts         = categoryData.productList.filter((product) => product.selected);
        const selectedProductsNames    = selectedProducts.map((product) => product.offerSubtitle + `${product.currentQty > 1 ? " (" + product.currentQty + ")" : ""}`);
        const finalCategoryDescription = selectedProductsNames.join(", ");

        $categoryDescription.html(finalCategoryDescription);
    }
};

const handleErrorOnCartUpdate = (err, currentScroll, lastInteractedCategory, lastInteractedAssetId) => {
    const $container  = $(".js-cart-container");
    const showCartUrl = $container.data("cart-show-url");

    console.error(err);

    if (err.responseJSON.redirectUrl) {
        $container.toggleClass("fetching", false);
        window.location.href = err.responseJSON.redirectUrl;
    } else if (err.responseJSON.data) {
        cartData = err.responseJSON.data;
        updateCartDataDataset($container, cartData);
        updateCartDOM(showCartUrl, $container, currentScroll, lastInteractedCategory, lastInteractedAssetId);
    }
};

const handleCategoryButtonClick         = ($editCategoryBtn, viabilityCheckURL) => {
    const $associatedCategoryCard = $editCategoryBtn.parents(".js-category-card");
    const categoryId              = $associatedCategoryCard.data("category-id").toString();
    const assetId                 = $associatedCategoryCard.data("asset-id")?.toString();
    const $categoryServices       = $(".js-category-content", $associatedCategoryCard);
    const isCartCategory          = !$associatedCategoryCard.data("customer-plan");

    const $container      = $(".js-cart-container");

    cartData = $container.data("cart-data");

    const expandedCategoryData    = isCartCategory ? cartData.categoryList.find((category) => category.categoryId === categoryId) : cartData.changeProductsList.find((category) => category.assetId.toString() === assetId);

    const isCloseBtn             = $editCategoryBtn.hasClass("js-close-category-btn");
    const isEditBtn              = $editCategoryBtn.hasClass("js-edit-category-btn");
    const requiresViabilityCheck = expandedCategoryData.requiresViabilityCheck;

    if (!cartData.wasViabilityAlreadyChecked && requiresViabilityCheck) {
        window.location.href = viabilityCheckURL;
        return;
    }

    if (isCloseBtn) {
        $associatedCategoryCard.removeClass("open");
        $categoryServices.css("max-height", 0);
        return;
    }

    $associatedCategoryCard.toggleClass("open");
    $categoryServices.css(
        "max-height",
        $associatedCategoryCard.hasClass("open") ? `${$categoryServices.prop("scrollHeight")}px` : 0
    );

    if (isEditBtn) {
        gtm.trackModify($associatedCategoryCard);
    }
};
const setCartInteractionsEventListeners = () => {
    const $container               = $(".js-cart-container");
    const $miniumQtyCartModal      = $(".js-cart-minimum-quantity-modal");
    const showCartUrl              = $container.data("cart-show-url");
    const updateCartUrl            = $container.data("cart-update-url");
    const addProductToCartURL      = $container.data("cart-add-url");
    const removeProductFromCartURL = $container.data("cart-remove-url");
    const viabilityCheckURL        = $container.data("viability-check-url");

    cartData = $container.data("cart-data");

    if ($container.length === 0) {
        return;
    }

    $(".js-modal-close", $miniumQtyCartModal).on("click", () => {
        $miniumQtyCartModal.removeClass("show");
    });

    const $categoryCards = $(".js-category-card");

    //When click on the Add/Edit/Close button of the category card, toggle the visual of the category products collapse
    $container.on("click", ".js-edit-category-btn, .js-add-category-btn, .js-close-category-btn", $categoryCards, function () {
        const width = $(window).width();

        if (width > breakpoints.md) {
            handleCategoryButtonClick($(this), viabilityCheckURL);
        }
    });

    //When click on the category card header, toggle the visual of the category products collapse
    $container.on("click", ".category-card__header", $categoryCards, function () {
        const width            = $(window).width();
        const $editCategoryBtn = $(this).find(".category-card__button-wrapper button:visible");

        if (width <= breakpoints.md) {
            handleCategoryButtonClick($editCategoryBtn, viabilityCheckURL);
        }
    });

    //Show the selected products in the description of the category card.
    $categoryCards.each(function () {
        const $categoryCard  = $(this);
        const categoryId     = $categoryCard.data("category-id").toString();
        const assetId        = $categoryCard.data("asset-id")?.toString();
        const isCartCategory = !$categoryCard.data("customer-plan");
        const categoryData   = isCartCategory ? cartData.categoryList.find((category) => category.categoryId === categoryId) : cartData.changeProductsList.find((category) => category.assetId.toString() === assetId);

        renderSelectedProductsOnCategoryCardDescription($categoryCard, categoryData);
    });

    //Initialize the empty card layout elements on startup in case the cart is empty
    toggleEmptyCartLayout($container, cartData);
    //Initialize the minicart visual elements on startup
    updateMiniCartDOM($container, cartData.minicart, !!cartData.customerPlan);
    ensureBlBannerVisibility($container, cartData);
    //Updated the counter on the header of the page.
    updateCartCounter(cartData.productsInCartQty);

    $container.on("click", ".js-remove-product, .cart-remove-icon", function (_event) {
        const $toggleProductBtn    = $(this);
        const assetId              = $toggleProductBtn.closest(".js-category-card").data("asset-id");
        const currentScroll        = document.documentElement.scrollTop || document.body.scrollTop;
        const isCartIconClick      = $toggleProductBtn.hasClass("cart-remove-icon");
        const $relatedStepperInput = $toggleProductBtn.parents(".js-product-tile").find(".js-stepper-input");
        let categoryId             = $toggleProductBtn.closest(".js-category-card").data("category-id");
        let productId              = $toggleProductBtn.data("product-id");
        let uuid                   = $toggleProductBtn.data("uuid");
        let operationType          = $toggleProductBtn.data("operation-type");
        let selectedProduct;

        function handleRemoveProduct() {
            $container.toggleClass("fetching", true);
            $.ajax({
                url: removeProductFromCartURL,
                type: "get",
                dataType: "json",
                data: {
                    pid: productId,
                    uuid: uuid,
                    operationType: operationType
                },
                success: function (response) {
                    if (response.error && response.errorMessage) {
                        $container.toggleClass("fetching", false);
                        return;
                    }

                    if (response.data) {
                        cartData = response.data;
                        updateCartDataDataset($container, cartData);
                    }

                    gtm.cartEvents(selectedProduct, constants.GTM.EVENTS.REMOVE_FROM_CART);

                    var pidStr  = String(productId || "");
                    var uuidStr = String(uuid != null && uuid !== "" ? uuid : "");
                    var $tile   = $(selectedProduct).closest(".js-product-tile");

                    if ($tile.length) {
                        $tile.remove();
                    }

                    var $removedLine = $container.find(".js-remove-item-summary").filter(function () {
                        return String($(this).attr("data-pid") || "") === pidStr && String($(this).attr("data-uuid") || "") === uuidStr;
                    }).closest("li.cart-summary__item-line");

                    if ($removedLine.length) {
                        var $summaryItem = $removedLine.closest(".js-cart-summary-item");

                        $removedLine.remove();

                        if ($summaryItem.find("li.cart-summary__item-line").length === 0) {
                            $summaryItem.remove();
                        }
                    }

                    var cartShowUrlBusted = appendQueryParams(showCartUrl, { _: Date.now() });

                    if (response.isFurtherReplacementRequired && response.replaceProductsAjaxUrl) {
                        productReplacementAjax(response.removedProductId, response.replaceProductsAjaxUrl, currentScroll, categoryId, assetId);
                    } else {
                        updateCartDOM(cartShowUrlBusted, $container, currentScroll, categoryId, assetId);
                    }

                    $relatedStepperInput?.val(0).trigger("change", true);
                    $relatedStepperInput?.data("old-value", 0);
                },
                error: function (err) {
                    $container.toggleClass("fetching", false);
                    handleErrorOnCartUpdate(err, currentScroll, categoryId, assetId);
                    updateCartDOM(appendQueryParams(showCartUrl, { _: Date.now() }), $container, currentScroll, categoryId, assetId);
                }
            });
        }

        if (isCartIconClick) {
            const $modal = $(".js-remove-products-modal");

            $modal.toggleClass("show", true);

            $(".js-remove-products-close", $modal).on("click", function () {
                $modal.toggleClass("show", false);
            });

            const categoryCardIndex = $(".cart-remove-icon:visible").index($toggleProductBtn);
            const selectedCategory  = $toggleProductBtn.closest(".js-category-card.selected");

            selectedProduct = $(".js-remove-product:not([hidden])")[categoryCardIndex];
            categoryId      = selectedCategory.data("category-id");
            uuid            = $(selectedProduct).data("uuid");
            productId       = $(selectedProduct).data("product-id");

            $(".js-remove-products-submit").off("click");

            $(".js-remove-products-submit").on("click", function () {
                handleRemoveProduct();
                selectedCategory.removeClass("open");
                $modal.toggleClass("show", false);
            });
        } else {
            selectedProduct = $toggleProductBtn;
            categoryId      = $toggleProductBtn.closest(".js-category-card").data("category-id");
            uuid            = $toggleProductBtn.data("uuid");
            productId       = $toggleProductBtn.data("product-id");

            handleRemoveProduct();
        }
    });

    $container.on("click", ".js-remove-item-summary", function (e) {
        e.preventDefault();
        e.stopPropagation();
        const $btn    = $(this);
        const pidStr  = String($btn.attr("data-pid") || "").trim();
        const uuidStr = String($btn.attr("data-uuid") || "").trim();

        if (!pidStr) {
            return;
        }

        const $modal = $(".js-remove-products-modal");

        $modal.data("remove-from-summary", { pidStr, uuidStr });
        $modal.toggleClass("show", true);

        $(".js-remove-products-close", $modal).off("click.removesummary").on("click.removesummary", function () {
            $modal.toggleClass("show", false);
            $modal.removeData("remove-from-summary");
        });

        $(".js-remove-products-submit", $modal).off("click.removesummary").on("click.removesummary", function () {
            const payload = $modal.data("remove-from-summary");

            if (!payload || !payload.pidStr) {
                return;
            }

            const scrollBeforeRemove = document.documentElement.scrollTop || document.body.scrollTop;

            $modal.toggleClass("show", false);
            $modal.removeData("remove-from-summary");
            const $liveContainer      = $(".js-cart-container");
            const pid                 = payload.pidStr;
            const uuid                = payload.uuidStr;
            var $tileToRemove         = $liveContainer.find(".js-product-tile").filter(function () {
                var $tileBtn = $(this).find(".js-remove-product");

                if (!$tileBtn.length) return false;

                var tilePid  = String($tileBtn.attr("data-product-id") || "").trim();
                var tileUuid = String($tileBtn.attr("data-uuid") || "").trim();

                return tilePid === pid && (uuid ? tileUuid === uuid : true);
            });
            var $categoryCardForMeta  = $tileToRemove.length ? $tileToRemove.closest(".js-category-card") : $();
            var categoryId            = $categoryCardForMeta.length ? $categoryCardForMeta.data("category-id") : undefined;
            var assetId               = $categoryCardForMeta.length ? $categoryCardForMeta.data("asset-id") : undefined;
            var operationType         = "";
            var selectedProductForGtm = null;
            var $relatedStepperInput  = null;

            if ($tileToRemove.length) {
                var $removeBtn        = $tileToRemove.find(".js-remove-product");

                operationType         = $removeBtn.data("operation-type") || "";
                selectedProductForGtm = $removeBtn[0];
                $relatedStepperInput  = $tileToRemove.find(".js-stepper-input");
            }

            if (!selectedProductForGtm) {
                var $serviceTile = $liveContainer.find(".js-service-tile").filter(function () {
                    var $tileBtn = $(this).find(".js-remove-service");

                    if (!$tileBtn.length) return false;
                    var tilePid  = String($tileBtn.attr("data-service-id") || "").trim();
                    var tileUuid = String($tileBtn.attr("data-service-uuid") || "").trim();

                    return tilePid === pid && (uuid ? tileUuid === uuid : true);
                });

                if ($serviceTile.length) {
                    $categoryCardForMeta  = $serviceTile.closest(".js-category-card");
                    categoryId            = $categoryCardForMeta.data("category-id");
                    assetId               = $categoryCardForMeta.data("asset-id");
                    selectedProductForGtm = $serviceTile.find(".js-remove-service")[0];
                    operationType         = $(selectedProductForGtm).data("operation-type") || "";
                }
            }

            lockScrollAnchoring();
            $container.toggleClass("fetching", true);
            $.ajax({
                url: removeProductFromCartURL,
                type: "get",
                dataType: "json",
                data: {
                    pid: pid,
                    uuid: uuid,
                    operationType: operationType
                },
                success: function (response) {
                    if (response.error && response.errorMessage) {
                        $container.toggleClass("fetching", false);
                        return;
                    }

                    if (response.data) {
                        cartData = response.data;
                        updateCartDataDataset($liveContainer, cartData);
                    }

                    if (selectedProductForGtm) {
                        gtm.cartEvents(selectedProductForGtm, constants.GTM.EVENTS.REMOVE_FROM_CART);
                    }

                    var pidStr              = String(pid || "");
                    var uuidStr             = String(uuid != null && uuid !== "" ? uuid : "");
                    var $removedLine        = $liveContainer.find(".js-remove-item-summary").filter(function () {
                        const btnPid  = String($(this).attr("data-pid") || "").trim();
                        const btnUuid = String($(this).attr("data-uuid") || "").trim();

                        return btnPid === pidStr && btnUuid === uuidStr;
                    }).closest("li.cart-summary__item-line");
                    let categoryBecameEmpty = false;
                    let emptiedCategoryId   = null;

                    if ($removedLine.length) {
                        const $summaryItem  = $removedLine.closest(".js-cart-summary-item");

                        categoryBecameEmpty = $summaryItem.find("li.cart-summary__item-line").length === 1;
                        emptiedCategoryId   = categoryBecameEmpty ? ($summaryItem.data("category-id") || $summaryItem.attr("data-category-id")) : null;
                        $removedLine.remove();

                        if ($summaryItem.find("li.cart-summary__item-line").length === 0) {
                            $summaryItem.remove();
                        }
                    }

                    var $tileToRemoveNow     = $liveContainer.find(".js-product-tile").filter(function () {
                        var $tileBtn = $(this).find(".js-remove-product");

                        if (!$tileBtn.length) return false;
                        var tilePid  = String($tileBtn.attr("data-product-id") || "").trim();
                        var tileUuid = String($tileBtn.attr("data-uuid") || "").trim();

                        return tilePid === pidStr && (uuidStr ? tileUuid === uuidStr : true);
                    });
                    var $categoryCardToClose = $();

                    if ($tileToRemoveNow.length) {
                        $categoryCardToClose = $tileToRemoveNow.closest(".js-category-card");
                        $tileToRemoveNow.remove();
                    }

                    var $serviceTileToRemove = $liveContainer.find(".js-service-tile").filter(function () {
                        var $tileBtn = $(this).find(".js-remove-service");

                        if (!$tileBtn.length) return false;
                        var tilePid  = String($tileBtn.attr("data-service-id") || "").trim();
                        var tileUuid = String($tileBtn.attr("data-service-uuid") || "").trim();

                        return tilePid === pidStr && (uuidStr ? tileUuid === uuidStr : true);
                    });

                    if ($serviceTileToRemove.length) {
                        $categoryCardToClose = $serviceTileToRemove.closest(".js-category-card");
                        $serviceTileToRemove.remove();
                    }

                    if ($categoryCardToClose.length) {
                        var $content = $(".js-category-content", $categoryCardToClose);

                        $categoryCardToClose.removeClass("open");
                        $content.css("max-height", 0);
                    }

                    if (categoryBecameEmpty && emptiedCategoryId && $categoryCardToClose.length) {
                        $categoryCardToClose.removeClass("selected");
                        var currentCartData = $liveContainer.data("cart-data");

                        if (currentCartData && currentCartData.categoryList) {
                            var cat = currentCartData.categoryList.find(function (c) {
                                return String(c.categoryId || "") === String(emptiedCategoryId || "");
                            });

                            if (cat) {
                                cat.selected   = false;
                                cat.currentQty = 0;

                                if (cat.productList) {
                                    cat.productList.forEach(function (p) {
                                        p.selected   = false;
                                        p.currentQty = 0;

                                        if (p.serviceOptionList) {
                                            p.serviceOptionList.forEach(function (s) {
                                                s.selected = false;
                                            });
                                        }
                                    });
                                }

                                updateCartDataDataset($liveContainer, currentCartData);
                            }
                        }

                        $categoryCardToClose.find(".js-remove-product").attr("hidden", "true");
                        $categoryCardToClose.find(".js-add-product").removeAttr("hidden").removeClass("disabled");
                        $categoryCardToClose.find(".js-remove-service").attr("hidden", "true");
                        $categoryCardToClose.find(".js-add-service").removeAttr("hidden").removeClass("disabled");

                        if (currentCartData && cat) {
                            renderSelectedProductsOnCategoryCardDescription($categoryCardToClose, cat);
                        }
                    }

                    if ($relatedStepperInput && $relatedStepperInput.length) {
                        $relatedStepperInput.val(0).trigger("change", true);
                        $relatedStepperInput.data("old-value", 0);
                    }

                    const cartShowUrlBusted = appendQueryParams(showCartUrl, { _: Date.now() });

                    if (response.isFurtherReplacementRequired && response.replaceProductsAjaxUrl) {
                        productReplacementAjax(response.removedProductId, response.replaceProductsAjaxUrl, scrollBeforeRemove, categoryId, assetId);
                    } else {
                        updateCartDOM(cartShowUrlBusted, $liveContainer, scrollBeforeRemove, categoryId, assetId);
                    }
                },
                error: function (err) {
                    $container.toggleClass("fetching", false);
                    handleErrorOnCartUpdate(err, undefined, undefined);
                    const cartShowUrl = appendQueryParams(showCartUrl, { _: Date.now() });

                    updateCartDOM(cartShowUrl, $container, scrollBeforeRemove, undefined, undefined);
                }
            });
        });
    });

    $container.on("click", ".js-add-product", function () {
        const $toggleProductBtn    = $(this);
        const categoryId           = $toggleProductBtn.closest(".js-category-card").data("category-id");
        const productIdList        = $toggleProductBtn.data("product-list");
        const assetId              = $toggleProductBtn.data("asset-id");
        const operationType        = $toggleProductBtn.data("operation-type");
        const currentScroll        = document.documentElement.scrollTop || document.body.scrollTop;
        const $relatedStepperInput = $toggleProductBtn.parents(".js-product-tile").find(".js-stepper-input");
        const currentLocality      = $(".currentLocationText").data("locality-id");

        $container.toggleClass("fetching", true);

        $.ajax({
            url: addProductToCartURL,
            type: "get",
            dataType: "json",
            data: {
                productIdList: productIdList || "",
                assetId: assetId || "",
                operationType: operationType || "",
                currentLocality: currentLocality
            },
            success: function (response) {
                if (response.isViabilityRequired) {
                    window.location.href = response.viabilityCheckUrl;
                    return;
                }

                gtm.cartEvents($toggleProductBtn, constants.GTM.EVENTS.ADD_TO_CART);
                cartData = response.data;
                // updateCartDataDataset($container, updatedData);
                updateCartDOM(showCartUrl, $container, currentScroll, categoryId, assetId);

                $relatedStepperInput?.val(1).trigger("change", true);
                $relatedStepperInput?.data("old-value", 0);
            },
            error: (err) => handleErrorOnCartUpdate(err, currentScroll, categoryId, assetId)
        });
    });

    $container.on("click", ".js-toggle-service", function () {
        const $toggleServiceBtn = $(this);
        const categoryId        = $toggleServiceBtn.closest(".js-category-card").data("category-id");
        const assetId           = $toggleServiceBtn.closest(".js-category-card").data("asset-id");
        const serviceId         = $toggleServiceBtn.data("service-id");
        const productId         = $toggleServiceBtn.data("product-id");
        const serviceUuid       = $toggleServiceBtn.data("service-uuid");
        const operationType     = $toggleServiceBtn.data("operation-type");
        const currentScroll     = document.documentElement.scrollTop || document.body.scrollTop;
        const isAddingService   = $toggleServiceBtn.hasClass("js-add-service");

        $container.toggleClass("fetching", true);

        $.ajax({
            url: isAddingService ? addProductToCartURL : removeProductFromCartURL,
            type: "get",
            dataType: "json",
            data: isAddingService ?  {
                productIdList: serviceId,
                associatedProductId: productId,
                assetId: assetId,
                operationType: operationType
            } : {
                pid: serviceId,
                uuid: serviceUuid,
                assetId: assetId,
                operationType: operationType
            },
            success: function (response) {
                if (!isAddingService && response.error && response.errorMessage) {
                    $container.toggleClass("fetching", false);
                    return;
                }

                if (response.data) {
                    cartData = response.data;
                    updateCartDataDataset($container, cartData);
                }

                gtm.cartEvents($toggleServiceBtn, constants.GTM.EVENTS.ADD_TO_CART);

                if (!isAddingService) {
                    var pidStr       = String(serviceId || "");
                    var uuidStr      = String(serviceUuid != null && serviceUuid !== "" ? serviceUuid : "");
                    var $serviceTile = $toggleServiceBtn.closest(".js-service-tile");

                    if ($serviceTile.length) {
                        $serviceTile.remove();
                    }

                    var $removedLine = $container.find(".js-remove-item-summary").filter(function () {
                        return String($(this).attr("data-pid") || "") === pidStr && String($(this).attr("data-uuid") || "") === uuidStr;
                    }).closest("li.cart-summary__item-line");

                    if ($removedLine.length) {
                        var $summaryItem = $removedLine.closest(".js-cart-summary-item");

                        $removedLine.remove();

                        if ($summaryItem.find("li.cart-summary__item-line").length === 0) {
                            $summaryItem.remove();
                        }
                    }
                }

                updateCartDOM(appendQueryParams(showCartUrl, { _: Date.now() }), $container, currentScroll, categoryId, assetId);
            },
            error: function (err) {
                $container.toggleClass("fetching", false);
                handleErrorOnCartUpdate(err, currentScroll, categoryId, assetId);

                if (!isAddingService) {
                    updateCartDOM(appendQueryParams(showCartUrl, { _: Date.now() }), $container, currentScroll, categoryId, assetId);
                }
            }
        });
    });

    // This flag is necessary because after the debounce period, the quantity on the input changes, triggering a "change" event
    // Because this event happen AFTER the debounce, it will trigger another AJAX call, so we need to prevent that.
    let quantityChanging = false;

    const onQuantityChanged = ($stepperInput) => {
        const $container      = $(".js-cart-container");

        cartData = $container.data("cart-data");

        const categoryId        = $stepperInput.closest(".js-category-card").data("category-id");
        const categoryDataIndex = cartData.categoryList.findIndex((category) => category.categoryId === categoryId.toString());
        const categoryData      = cartData.categoryList[categoryDataIndex];
        const productId         = $stepperInput.data("product-id");
        const uuid              = $stepperInput.data("product-uuid");
        const productIdList     = $stepperInput.data("product-list");
        const oldValue          = parseInt($stepperInput.data("old-value"), 10);
        const currentScroll     = document.documentElement.scrollTop || document.body.scrollTop;
        let quantity            = parseInt($stepperInput.val(), 10);

        if (!quantity || Number.isNaN(quantity)) {
            // If the input is an invalid number (such as an empty string) then set the quantity to 0 as fallback, to removed the product.
            if (oldValue !== 0) {
                quantity = 0;
            } else {
                // If the user put an invalid number into a product with a value of 0, then nothing needs to be done.
                return;
            }
        }

        const isAdd    = quantity !== 0 && oldValue === 0;
        const isUpdate = quantity !== 0 && oldValue !== 0;
        const isRemove = quantity === 0 && oldValue !== 0;

        //If the quantity is 0, use the remove URL
        //If the quantity was 0, and now is more than 0, use the add URL
        //Otherwise, use the default UpdateQuantity url
        const ajaxURl  = isRemove ? removeProductFromCartURL : isAdd ? addProductToCartURL : updateCartUrl;
        const gtmLabel = isRemove ? "remove_from_cart" : "add_to_cart";

        // Check if the set quantity is going to be higher than the maximum set for the category, if it is, set the quantity to the maximum allowed minus the current.
        const quantityToSet = quantity !== 0
            ? (categoryData.currentQty || 0) + quantity - (isUpdate ? oldValue : 0) > categoryData.maxQty
                ? categoryData.maxQty - ((categoryData.currentQty || 0) - (isUpdate ? oldValue : 0))
                : quantity
            : 0;

        $stepperInput?.val(quantityToSet).trigger("change", true);

        if (quantityToSet === oldValue) {
            return;
        }

        quantityChanging = true;
        $container.toggleClass("fetching", true);
        $.ajax({
            url: ajaxURl,
            type: "get",
            dataType: "json",
            data: {
                pid: productId,
                uuid: uuid,
                quantity: quantityToSet,
                productIdList: productIdList
            },
            success: function (response) {
                cartData = response.data;
                $container.data("cart-data", JSON.stringify(cartData));
                $container.attr("data-cart-data", JSON.stringify(cartData));
                gtm.cartEvents($stepperInput, gtmLabel);
                updateCartDOM(showCartUrl, $container, currentScroll, categoryId);
                $stepperInput.data("old-value", quantityToSet);
            },
            error:  (err) => handleErrorOnCartUpdate(err, currentScroll, categoryId),
            complete: () => {
                quantityChanging = false;
            }
        });
    };

    const debounceOnProductQuantityChange = debounce(onQuantityChanged, 1000);

    $container.on("change keyup", ".js-stepper-input", function (e, isSytheticEvent) {
        // Check if the event was triggered naturally or trough the steppers buttons, if it was sythethic, don't start the debounced function.
        if (!isSytheticEvent && !quantityChanging) {
            debounceOnProductQuantityChange($(this));
        }
    });

    $container.on("click", ".js-stepper-minus, .js-stepper-plus, .js-stepper-trash", function () {
        const $clickedStepperBtn = $(this);
        const $stepperInput      = $clickedStepperBtn.siblings(".js-stepper-input");
        const categoryId         = $clickedStepperBtn.closest(".js-category-card").data("category-id");
        const assetId            = $clickedStepperBtn.closest(".js-category-card").data("asset-id");
        const productId          = $stepperInput.data("product-id");
        const uuid               = $stepperInput.data("product-uuid");
        const productIdList      = $stepperInput.data("product-list");
        const operationType      = $stepperInput.data("operation-type");
        const quantity           = parseInt($stepperInput.val(), 10) + ($clickedStepperBtn.hasClass("js-stepper-plus") ? 1 : -1);
        const currentScroll      = document.documentElement.scrollTop || document.body.scrollTop;

        //If the quantity is 0, use the remove URL
        //If the quantity is 1, and the button clicked was the plus one, use the add URL
        //Otherwise, use the default UpdateQuantity url
        const ajaxURl  = quantity === 0 ? removeProductFromCartURL : $clickedStepperBtn.hasClass("js-stepper-plus") && quantity === 1 ? addProductToCartURL : updateCartUrl;
        const gtmLabel = quantity === 0 ? "remove_from_cart" : "add_to_cart";

        $stepperInput.trigger("change", true);
        $container.toggleClass("fetching", true);
        $.ajax({
            url: ajaxURl,
            type: "get",
            dataType: "json",
            data: {
                pid: productId,
                uuid: uuid,
                quantity: quantity,
                productIdList: productIdList,
                operationType: operationType
            },
            success: function (response) {
                cartData = response.data;
                $container.data("cart-data", JSON.stringify(cartData));
                $container.attr("data-cart-data", JSON.stringify(cartData));
                gtm.cartEvents($clickedStepperBtn, gtmLabel);
                updateCartDOM(showCartUrl, $container, currentScroll, categoryId, assetId);
                $stepperInput.data("old-value", quantity);
            },
            error:  (err) => handleErrorOnCartUpdate(err, currentScroll, categoryId)
        });
    });

    $container.on("click", ".js-cart-submit-btn", function (e) {
        const cartData       = $container.data("cart-data");
        const cartDataParsed = typeof cartData === "string" ? JSON.parse(cartData) : cartData;
        const $cartSubmitBtn = $(this);

        //Disabled redirect of the Cart Submit button link in case it's disabled because the cart is empty.
        if ($cartSubmitBtn.hasClass("disabled") || !cartDataParsed.isReadyForCheckout) {
            e.preventDefault();
        }
    });

    $container.on("submit", ".js-promo-code-form", function (e) {
        e.preventDefault();

        const $promoCodeForm = $(this);
        const url            = $promoCodeForm.attr("action");
        const data           = $promoCodeForm.serialize();
        const currentScroll  = document.documentElement.scrollTop || document.body.scrollTop;
        const $couponInput   = $promoCodeForm.find(".coupon-code-field");
        const $addCouponBtn  = $promoCodeForm.find(".js-add-coupon");

        $addCouponBtn.addClass("btn-loading");

        $.ajax({
            url,
            type: "GET",
            dataType: "json",
            data,
            success: function (response) {
                if (response.error) {
                    $couponInput.val("");
                    $couponInput.addClass("is-invalid");
                    $couponInput.attr("aria-describedby", "invalidCouponCode");
                    $promoCodeForm.find(".coupon-missing-error").empty();
                    $promoCodeForm.find(".coupon-error-message").empty().append(response.errorMessage || "Cupom inválido");
                    $addCouponBtn.removeClass("btn-loading");
                    return;
                }

                const couponValue = $couponInput.val();
                const discounts   = response.totals ? response.totals.discounts : [];
                const discount    = discounts.find(d => d.couponCode && d.couponCode.toUpperCase() === couponValue.toUpperCase());

                $couponInput.val("");
                $couponInput.removeClass("is-invalid");
                $promoCodeForm.find(".coupon-missing-error").empty();
                $promoCodeForm.find(".coupon-error-message").empty();

                if (discount && !discount.applied) {
                    removeInvalidCoupon($promoCodeForm, discount)
                        .always(function () {
                            updateCoupon(showCartUrl, $container, response, true)
                                .always(function () {
                                    showInvalidCouponProductsFeedback($promoCodeForm);
                                    $addCouponBtn.removeClass("btn-loading");
                                });
                        });

                    return;
                }

                updateCoupon(showCartUrl, $container, response);
            },
            error: (err) => {
                handleErrorOnCartUpdate(err, currentScroll);
                $addCouponBtn.removeClass("btn-loading");
            }
        });
    });

    $container.on("click", ".js-remove-coupon", function (e) {
        e.preventDefault();

        const url                  = $(this).data("action");
        const couponCode           = $(this).data("code");
        const $productToRemoveSpan = $(".product-to-remove");
        const currentScroll        = document.documentElement.scrollTop || document.body.scrollTop;

        $(this).addClass("btn-loading");

        $productToRemoveSpan.empty().append(couponCode);

        $.ajax({
            url: url,
            type: "get",
            dataType: "json",
            success: function (data) {
                updateCoupon(showCartUrl, $container, data.data);
            },
            error: (err) => {
                handleErrorOnCartUpdate(err, currentScroll);
                $(this).removeClass("btn-loading");
            }
        });
    });
};

const setCardButtonClasses = () => {
    const $categoryButtons = $(".category-card__button-wrapper button");
    const width            = $(window).width();

    if (width < breakpoints.md) {
        $categoryButtons.removeClass("btn-primary").removeClass("btn-secondary");
    }
};

const initializeEmptyCartModal = () => {
    const $container      = $(".js-cart-container");
    const $modal          = $(".js-empty-cart-modal");
    const $openModalBtn   = $(".js-open-empty-modal");
    const $closeModalBtn  = $(".js-empty-cart-close");
    const $submitModalBtn = $(".js-empty-cart-submit");
    const emptyCartUrl    = $openModalBtn.attr("data-empty-cart-url");

    $openModalBtn.on("click", function () {
        $modal.toggleClass("show", true);
    });

    $closeModalBtn.on("click", function () {
        $modal.toggleClass("show", false);
    });

    $submitModalBtn.on("click", function () {
        $container.toggleClass("fetching", true);
        window.location.href = emptyCartUrl;
    });
};

const initializeNBOModal = () => {
    const $modal         = $(".js-nbo-modal");
    const $nboCloseModal = $(".js-nbo-close");

    if ($modal.length) {
        $modal.toggleClass("show", true);
    }

    $nboCloseModal.on("click", function () {
        $modal.toggleClass("show", false);
    });
};

const initializeRedirectToCheckoutErrorModal = () => {
    const $modal      = $(".js-redirect-to-checkout-error-modal");
    const $closeModal = $(".js-redirect-to-checkout-error-close");

    if ($modal.length) {
        $modal.toggleClass("show", true);
    }

    $closeModal.on("click", function () {
        $modal.toggleClass("show", false);
    });
};

const initializePlanConflictModal = () => {
    const $planConflictModal = $(".js-plan-conflict-modal");
    const shouldDisplayModal = $planConflictModal.data("should-display-modal-cart-page");

    if (shouldDisplayModal) {
        $planConflictModal.find(".js-plan-conflict-submit").attr("is-add-product", false);
        $planConflictModal.toggleClass("show", true);
    }
};

/**
 * Handles standard label download
 */
function handleStandardLabelDownload() {
    $(document).on("click", ".js-standard-label-link", function (e) {
        e.preventDefault();
        const $link   = $(this);
        const $status = $(".js-standard-label-status");
        const url     = $link.data("url");

        const Resources = {
            LABEL_GENERATING : $(".js-standard-label-link").data("generating"),
            LABEL_SUCCESS    : $(".js-standard-label-link").data("success"),
            LABEL_ERROR      : $(".js-standard-label-link").data("error"),
        };

        $status.text(Resources.LABEL_GENERATING).addClass("generating");
        $link.addClass("disabled");

        $.ajax({
            url: url,
            type: "GET",
            dataType: "json",
            success: function (data) {
                if (data.success && data.downloadUrl) {
                    $status.text(Resources.LABEL_SUCCESS).removeClass("generating").addClass("success");
                    downloadPDF(data.downloadUrl)
                        .then(() => {
                            $status.text(Resources.LABEL_SUCCESS).removeClass("generating").addClass("success");
                        });
                } else {
                    $status.text(Resources.LABEL_ERROR).removeClass("generating").addClass("error");
                }
            },
            error: function () {
                $status.text(Resources.LABEL_ERROR).removeClass("generating").addClass("error");
            },
            complete: function () {
                setTimeout(function () {
                    $link.removeClass("disabled");
                    $status.text("").removeClass("success error generating");
                }, 5000);
            }
        });
    });
}

const downloadPDF = url => new Promise((resolve, reject) => {
    fetch(url, {
        headers: {
            "Content-Type": "application/json; charset=utf-8" },
    })
        .then(response => response.blob())
        .then(response => {
            const blob        = new Blob([response], {type: "application/pdf"});
            const downloadUrl = URL.createObjectURL(blob);
            const a           = document.createElement("a");

            a.href     = downloadUrl;
            a.download = "etiquetaPadrao.pdf";
            document.body.appendChild(a);
            a.click();
            a.remove();
            resolve();
        }).catch(error => {
            reject(error);
        });
});

const handleURLAnchor = () => {
    let anchorArray = window.location.href.split('#');
    let anchor;
    let categoryAddButton;

    if (anchorArray.length > 1) anchor = anchorArray[1];

    if (anchor) {
        categoryAddButton = document.querySelector("button.js-add-category-btn[data-category-id='" + anchor + "']");
        if (categoryAddButton) {
            categoryAddButton.click();
            scrollAnimate($(categoryAddButton).parents('div.category-card'));
        }
    }
}

const initializeCart = () => {
    setCollapsableElementsEventListeners();
    setCartInteractionsEventListeners();
    gtm.viewCartEvent();
    setCardButtonClasses();
    initializeEmptyCartModal();
    initializeCartFaq();
    initializeNBOModal();
    initAddToCartNBOListener();
    initializeRedirectToCheckoutErrorModal();
    initializePlanConflictModal();
    handleStandardLabelDownload();
    handleURLAnchor();
};

export default initializeCart;
